import React from 'react';
import './IconText.css'

const classNames = require('classnames');
export default function IconText(props: {
    children?: React.ReactNode,
    className?: string,
    src?: string,
    alt?: string,
    onClick?: () => void
    title?: string
}) {
    return (
        <div className={classNames("icon-text text-nowrap text-truncate ", props.className)} onClick={props.onClick} title={props.title}>
            {props.src ? <img className="img-fluid" src={props.src} alt={props.alt} /> : null}
            <span className="">{props.children}</span>
        </div>
    )
}